export const QUARTERS = ["Q1", "Q2", "Q3", "Q4"];

export const MONTHS = [
  "Jan",
  "Feb",
  "Mar",
  "Apr",
  "May",
  "Jun",
  "Jul",
  "Aug",
  "Sep",
  "Oct",
  "Nov",
  "Dec",
];

export const formatMonth = (month, language = "en") =>
  new Date(2000, month - 1).toLocaleString(language, { month: "short" });

export const formatReportingYearPeriod = (reportingYear, language = "en") => {
  if (!reportingYear) return "";

  const startMonth = new Date(
    2000,
    reportingYear.startMonth - 1,
  ).toLocaleString(language, { month: "short" });
  const endMonth = new Date(2000, reportingYear.endMonth - 1).toLocaleString(
    language,
    { month: "short" },
  );

  return `${reportingYear.startYear} (${startMonth} ${reportingYear.startYear} - ${endMonth} ${reportingYear.endYear} )`;
};
